/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {
  OffsetDateTime,
  LocalDate,
} from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { OperationsTaskDetails } from "./OperationsTaskDetails";
import {
  OperationsTaskDetailsFromJSON,
  OperationsTaskDetailsFromJSONTyped,
  OperationsTaskDetailsToJSON,
  OperationsTaskDetailsToJSONTyped,
} from "./OperationsTaskDetails";
import type { ShipmentLocationInfo } from "./ShipmentLocationInfo";
import {
  ShipmentLocationInfoFromJSON,
  ShipmentLocationInfoFromJSONTyped,
  ShipmentLocationInfoToJSON,
  ShipmentLocationInfoToJSONTyped,
} from "./ShipmentLocationInfo";

/**
 *
 * @export
 * @interface ShipmentWithOperationsTask
 */
export interface ShipmentWithOperationsTask {
  /**
   *
   * @type {string}
   * @memberof ShipmentWithOperationsTask
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentWithOperationsTask
   */
  proNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShipmentWithOperationsTask
   */
  billOfLadingNumber?: string | null;
  /**
   *
   * @type {ShipmentLocationInfo}
   * @memberof ShipmentWithOperationsTask
   */
  pickupLocation: ShipmentLocationInfo;
  /**
   *
   * @type {ShipmentLocationInfo}
   * @memberof ShipmentWithOperationsTask
   */
  deliveryLocation: ShipmentLocationInfo;
  /**
   *
   * @type {LocalDate}
   * @memberof ShipmentWithOperationsTask
   */
  pickupDate: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof ShipmentWithOperationsTask
   */
  expectedDeliveryDate?: LocalDate | null;
  /**
   *
   * @type {string}
   * @memberof ShipmentWithOperationsTask
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentWithOperationsTask
   */
  companyName: string;
  /**
   *
   * @type {OperationsTaskDetails}
   * @memberof ShipmentWithOperationsTask
   */
  operationsTask: OperationsTaskDetails;
  /**
   *
   * @type {string}
   * @memberof ShipmentWithOperationsTask
   */
  operationsAssignedTo?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ShipmentWithOperationsTask
   */
  operationsAssignedAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ShipmentWithOperationsTask
   */
  trackingLineLastUpdate?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof ShipmentWithOperationsTask
   */
  trackingLineMessage?: string | null;
}

/**
 * Check if a given object implements the ShipmentWithOperationsTask interface.
 */
export function instanceOfShipmentWithOperationsTask(
  value: object,
): value is ShipmentWithOperationsTask {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("pickupLocation" in value) || value["pickupLocation"] === undefined)
    return false;
  if (!("deliveryLocation" in value) || value["deliveryLocation"] === undefined)
    return false;
  if (!("pickupDate" in value) || value["pickupDate"] === undefined)
    return false;
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("companyName" in value) || value["companyName"] === undefined)
    return false;
  if (!("operationsTask" in value) || value["operationsTask"] === undefined)
    return false;
  return true;
}

export function ShipmentWithOperationsTaskFromJSON(
  json: any,
): ShipmentWithOperationsTask {
  return ShipmentWithOperationsTaskFromJSONTyped(json, false);
}

export function ShipmentWithOperationsTaskFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentWithOperationsTask {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    proNumber: json["proNumber"] == null ? undefined : json["proNumber"],
    billOfLadingNumber:
      json["billOfLadingNumber"] == null
        ? undefined
        : json["billOfLadingNumber"],
    pickupLocation: ShipmentLocationInfoFromJSON(json["pickupLocation"]),
    deliveryLocation: ShipmentLocationInfoFromJSON(json["deliveryLocation"]),
    pickupDate: json["pickupDate"],
    expectedDeliveryDate:
      json["expectedDeliveryDate"] == null
        ? undefined
        : json["expectedDeliveryDate"],
    carrierIdentifier: json["carrierIdentifier"],
    companyName: json["companyName"],
    operationsTask: OperationsTaskDetailsFromJSON(json["operationsTask"]),
    operationsAssignedTo:
      json["operationsAssignedTo"] == null
        ? undefined
        : json["operationsAssignedTo"],
    operationsAssignedAt:
      json["operationsAssignedAt"] == null
        ? undefined
        : json["operationsAssignedAt"],
    trackingLineLastUpdate:
      json["trackingLineLastUpdate"] == null
        ? undefined
        : json["trackingLineLastUpdate"],
    trackingLineMessage:
      json["trackingLineMessage"] == null
        ? undefined
        : json["trackingLineMessage"],
  };
}

export function ShipmentWithOperationsTaskToJSON(
  json: any,
): ShipmentWithOperationsTask {
  return ShipmentWithOperationsTaskToJSONTyped(json, false);
}

export function ShipmentWithOperationsTaskToJSONTyped(
  value?: ShipmentWithOperationsTask | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    proNumber: value["proNumber"],
    billOfLadingNumber: value["billOfLadingNumber"],
    pickupLocation: ShipmentLocationInfoToJSON(value["pickupLocation"]),
    deliveryLocation: ShipmentLocationInfoToJSON(value["deliveryLocation"]),
    pickupDate: value["pickupDate"],
    expectedDeliveryDate: value["expectedDeliveryDate"],
    carrierIdentifier: value["carrierIdentifier"],
    companyName: value["companyName"],
    operationsTask: OperationsTaskDetailsToJSON(value["operationsTask"]),
    operationsAssignedTo: value["operationsAssignedTo"],
    operationsAssignedAt: value["operationsAssignedAt"],
    trackingLineLastUpdate: value["trackingLineLastUpdate"],
    trackingLineMessage: value["trackingLineMessage"],
  };
}
